// extracted by mini-css-extract-plugin
export default {"timeDiv":"AppointmentTime_timeDiv__PmC69","timeButton":"AppointmentTime_timeButton__v8O7w","timeButton2":"AppointmentTime_timeButton2__IpHpN"};